<div class="svg-loader" *ngIf="isLoading"></div>
<div class="reportBody">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()"></a>
  </div>
  <div class="modelTitle alignCenter heading2">
    Flowsheet Simulation Report
  </div>
  <div class="d-flex table-container flowsheetTable">
    <div class="col-sm-12">
      <div class="row my-4 pad-lr">
        <div class="col-sm-5">          
          <label for="flowsheetName" class="form-label"><strong>Flowsheet Name:</strong> {{flowSheetRunData.flowSheetName}}</label>
        </div>
        <div class="col-sm-3">
          <label for="flowsheetStatus" class="form-label"><strong>Status:</strong> {{flowSheetRunData.status}}</label>
        </div>
        <div class="col-sm-4">
          <label for="startTime" class="form-label"><strong>Simulation Trigger Time:</strong> {{flowSheetRunData.startTime | date: 'yyyy-M-dd T HH:mm:ss' }}</label>   
        </div>
      </div>
      <div class="row mb-15 pad-lr mb-3">
        <div class="col-sm-5">
          <div class="row">
            <div class="col-sm-2">
              <label for="selModel" class="form-label"><strong>Model:</strong></label>
            </div>
            <div class="col-sm-7">
              <select class="custom-select form-control" id="selModel" [(ngModel)]="selModel" name="selModel"
                (change)="showParameters()" tabindex="-1">
                <option *ngFor="let item of modelDataList" [ngValue]="item">{{item.modelUniqueId}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <label for="selModelStatus" class="form-label"><strong>Status:</strong> {{selModel.status}}</label>
        </div>
        <div class="col-sm-4">
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex table-container flowsheetTable mb-4" *ngIf="isShowParam">
    <div class="col-sm-6 division">
      <div class="modelTitle alignCenter heading2">
        Inputs
      </div>
      <div class="fixed-height">
        <mat-table #paramTable [dataSource]="inputDataSource">
          <ng-container matColumnDef="parameterName">
            <mat-header-cell *matHeaderCellDef>Parameter</mat-header-cell>
            <mat-cell *matCellDef="let element" title="{{element.parameterName}}"> {{element.parameterDisplayName}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="paramDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: paramDisplayedColumns;"></mat-row>
        </mat-table>
      </div>
    </div>
    <div class="col-sm-6 division border-right-0">
      <div class="modelTitle alignCenter heading2">
        Outputs
      </div>
      <div class="fixed-height">
        <mat-table #paramTable [dataSource]="outputDataSource">
          <ng-container matColumnDef="parameterName">
            <mat-header-cell *matHeaderCellDef>Parameter</mat-header-cell>
            <mat-cell *matCellDef="let element" title="{{element.parameterName}}"> {{element.parameterDisplayName}}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="value">
            <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="paramDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: paramDisplayedColumns;"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>
</div>
  